import { Pipe, PipeTransform } from '@angular/core';
import { Currency } from '../models/enums/currency';
import { CurrencyUtil } from '../utils/currency.util';

@Pipe({
  name: 'dynamicCurrency'
})
export class DynamicCurrencyPipe implements PipeTransform {
  
  transform(value: number, currency?: Currency, maxFractionDigits: number = 2): string {
    const currencyToUse = currency || Currency.BRL;
    const effectiveMax = currencyToUse === Currency.BRL ? 2 : maxFractionDigits;
    return CurrencyUtil.formatCurrency(value, currencyToUse, effectiveMax);
  }
} 